import useRefCode from "@casino/legacy/client/hooks/cookies/marketing/useRefCode";
import useOtpValue from "@casino/legacy/client/hooks/cookies/useOtpValue";
import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useSite from "@casino/legacy/client/hooks/useSite";
import FRIENDREF_COOKIE from "@workspace/casino_config/cookies/FRIENDREF_COOKIE";
import REF_AFF from "@workspace/casino_config/cookies/REF_AFF";
import { useCognitoMutation } from "@workspace/casino_core/mutations/CognitoMutation.client";
import { getCookie } from "@workspace/cookies/browser";

const useCognitoAuthenticate = () => {
  const { site } = useSite();
  const { code: language } = useLanguage();
  const refCode = useRefCode();
  const refAff = getCookie(REF_AFF);
  const friendRef = getCookie(FRIENDREF_COOKIE);
  const cid = getCookie("cid");
  const [auth] = useCognitoMutation();
  const [otp] = useOtpValue();

  const handleAuth = async (accessToken: string) =>
    auth({
      // Read when sending, not during render: the hook also renders on the server.
      domain: window.location.hostname,
      language,
      site,
      refCode,
      refAff,
      cid,
      accessToken,
      otp,
      friendRef,
    });

  return { handleAuth };
};

export default useCognitoAuthenticate;
